import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import Icon from '../../../components/Icon';
export function CodeCoverageChangedLinesSummary({ diff, value }) {
    const { t } = useTranslation();
    if (!value) {
        return null;
    }
    return (_jsxs("div", { children: [`${t('codeCoverage.changedLines')}: ${Math.round(value * 100) / 100}%`, typeof diff === 'number' && diff !== 0 && (_jsxs("span", { className: "text-nowrap", children: [' ', _jsx(Icon, { className: clsx('report-detail__icon', 'report-detail__icon--small', (diff ?? 0) < 0 ? 'icon--rotate-90deg' : 'icon--rotate-270deg'), name: "long-arrow-right" }), `${Math.round(diff * 100) / 100}%`] }))] }));
}
